import { render } from "./DeleteReportCard.vue?vue&type=template&id=03c0e17b"
import script from "./DeleteReportCard.vue?vue&type=script&lang=js"
export * from "./DeleteReportCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__